import { Clock, CheckCircle2, Phone } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { SiteFooter } from "../components/SiteFooter";
import { PageHero } from "../components/PageHero";
import { BUSINESS, IMAGES, SELF_SERVE, VACUUM, MAT_CLEANER, MAT_CLEANER_STEPS } from "../lib/business";

export default function SelfServe() {
  return (
    <div className="min-h-screen bg-background grain">
      <Navbar />
      <PageHero testid="self-serve-hero" eyebrow="New — Self-Serve Bays" title={<>Wash It<br />Your Way.</>} image={IMAGES.selfServe}
        text={`Pay-as-you-go self-service bays ${BUSINESS.site.replace("At ", "at ")}. Time-based pricing — you only pay for the time you use.`}>
        <div className="mt-10 flex flex-wrap items-baseline gap-2" data-testid="self-serve-price">
          <span className="overline text-muted-foreground">From</span>
          <span className="font-head font-black text-5xl text-white">{SELF_SERVE.from}</span>
          <span className="overline text-muted-foreground">for {SELF_SERVE.per}</span>
        </div>
      </PageHero>

      <section className="mx-auto max-w-7xl px-6 py-20 grid lg:grid-cols-2 gap-12 items-start">
        <img src={IMAGES.selfServe} alt="Earlwood self service car wash bays" className="w-full h-[360px] object-cover border border-white/10" />
        <div>
          <div className="overline text-volt mb-3 flex items-center gap-2"><Clock className="w-4 h-4" /> Open {SELF_SERVE.hours}, 7 days</div>
          <h2 className="font-head font-extrabold text-3xl md:text-4xl uppercase tracking-tight mb-6">In Every Bay</h2>
          <div className="border border-white/10">
            {SELF_SERVE.features.map((f) => (
              <div key={f} className="flex items-center gap-3 p-4 border-b border-white/10 last:border-b-0">
                <CheckCircle2 className="w-5 h-5 text-volt shrink-0" />
                <span className="text-sm tracking-wide">{f}</span>
              </div>
            ))}
          </div>
          {[[VACUUM, "self-serve-vacuum-price", "(separate)"], [MAT_CLEANER, "self-serve-mat-cleaner-price", "— clean all your car mats"]].map(([x, id, tag]) => (
            <div key={id} className="mt-4 border border-white/10 p-4 flex items-center justify-between" data-testid={id}>
              <span className="text-sm tracking-wide">{x.name} {tag}</span>
              <span className="font-head font-black text-xl">{x.price} <span className="overline text-muted-foreground">/ {x.sub}</span></span>
            </div>
          ))}
          <a href={BUSINESS.phoneHref} data-testid="self-serve-call-btn" className="mt-8 inline-flex items-center gap-2 border border-white/20 px-6 py-3 overline hover:border-volt transition-colors">
            <Phone className="w-4 h-4 text-volt" /> Call {BUSINESS.phone}
          </a>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-6 pb-20 grid lg:grid-cols-2 gap-12 items-start" data-testid="vacuum-mat-section">
        <img src={IMAGES.vacuumMat} alt="Car mat cleaner and vacuum bays" className="w-full h-auto border border-white/10" />
        <div>
          <div className="overline text-volt mb-3">Vacuums & Mat Cleaner</div>
          <h2 className="font-head font-extrabold text-3xl md:text-4xl uppercase tracking-tight mb-6">Finish The Inside</h2>
          <p className="text-sm text-muted-foreground tracking-wide mb-6">Dedicated vacuum parking bays — {VACUUM.price} for {VACUUM.sub}. Car mat cleaner — {MAT_CLEANER.price} for {MAT_CLEANER.sub}, cleans all your car mats.</p>
          <div className="overline text-muted-foreground mb-3">Using The Mat Cleaner</div>
          <div className="border border-white/10" data-testid="mat-cleaner-steps">
            {MAT_CLEANER_STEPS.map((t, i) => (
              <div key={t} className="flex items-center gap-4 p-4 border-b border-white/10 last:border-b-0">
                <span className="font-head font-black text-2xl text-volt w-8">{i + 1}</span>
                <span className="text-sm tracking-wide uppercase">{t}</span>
              </div>
            ))}
          </div>
          <p className="overline text-volt mt-4">No children to use · Be careful of moving parts</p>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
